var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"est-domicilios"},[_c('navigation'),_c('estados_domicilios')],1)}
var staticRenderFns = []

export { render, staticRenderFns }